export const faceSwapeEnvOptions = {
    environment: {
      environmentAtmosphere: {
        label: '環境氛圍',
        options: {
          warmSunlight: '溫暖陽光',
          coolTone: '冷調',
          darkAtmosphere: '暗黑氛圍',
          cloudyHazy: '陰天/霧霾環境',
          lightThroughWindow: '光線透過窗戶'
        }
      },
      lightStyle: {
        label: '燈光類型',
        options: {
          naturalSunlight: '自然陽光',
          softAmbientLight: '柔和環境光',
          harshSunlight: '強烈陽光',
          overcastSky: '陰天',
          sunsetGlow: '日落餘暉',
          candlelight: '燭光',
          moonlight: '月光',
          backlitSilhouette: '逆光剪影',
          spotlight: '聚光燈',
          rimLighting: '邊緣光',
          studioLighting: '攝影棚燈光',
          goldenHourLight: '黃金時刻光線',
          blueHourLight: '藍色時刻光線',
          neonLights: '霓虹燈'
        }
      },
      lightDirection: {
        label: '燈光方向',
        options: {
          fromTop: '從上方',
          fromBottom: '從下方',
          fromRight: '從右側',
          fromLeft: '從左側',
          fromFront: '從前方',
          fromTopRight: '從右上方',
          fromTopLeft: '從左上方'
        }
      },
      background: {
        label: '背景',
        options: {
          naturalLandscape: '自然景觀',
          urbanBackground: '城市背景',
          simpleBackground: '簡單背景',
          indoorBackground: '室內背景',
          virtualBackground: '虛擬背景'
        }
      },
      backgroundEffect: {
        label: '背景效果',
        options: {
          dynamicBackground: '動態背景',
          neonLightBackground: '霓虹燈背景',
          starrySkyBackground: '星空背景',
          fogMistEffect: '霧霾/霧氣效果',
          minimalistBackground: '極簡背景'
        }
      },
      backgroundBlur: {
        label: '背景虛化',
        options: {
          slightBlur: '輕度虛化',
          strongBlur: '強烈虛化',
          hazeEffect: '霧霾效果'
        }
      }
    }
  };
